import maplibregl from 'maplibre-gl'
import { PMTiles, Protocol } from 'pmtiles'

class PmtilesMap extends maplibregl.Map {
  private static protocol: Protocol | null = null
  private static registered = new Map<string, PMTiles>()

  private static ensureProtocol() {
    if (!PmtilesMap.protocol) {
      const protocol = new Protocol()
      maplibregl.addProtocol('pmtiles', protocol.tile.bind(protocol))
      PmtilesMap.protocol = protocol
    }
    return PmtilesMap.protocol
  }

  static registerSource(filename: string) {
    const protocolInstance = PmtilesMap.ensureProtocol()
    const absoluteUrl =
      typeof window !== 'undefined' ? `${window.location.origin}/${filename}` : `/${filename}`
    const pmtilesUrl = `pmtiles://${absoluteUrl}`

    if (!PmtilesMap.registered.has(pmtilesUrl)) {
      const pmtiles = new PMTiles(absoluteUrl)
      protocolInstance.add(pmtiles)
      PmtilesMap.registered.set(pmtilesUrl, pmtiles)
    }

    return pmtilesUrl
  }

  constructor(options: maplibregl.MapOptions) {
    PmtilesMap.ensureProtocol()
    super(options)
  }
}

export default PmtilesMap
